import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import NumberInput from 'semantic-ui-react-numberinput'
import { Form } from 'semantic-ui-react'

const IntensityFormField = props => {
    let value = Number(props.value || 1)

    if (Number.isNaN(value)) {
        value = 1
    }

    value = Math.min(value, props.maxValue)

    return (
        <Form.Field width={props.width}>
            <label>{props.label}</label>
            <Form.Input
                {...props}
                as={NumberInput}
                value={`${value}`}
                buttonPlacement="leftAndRight"
                onChange={value => props.onChange({ target: { value } })}
                minValue={1}
                maxValue={props.maxValue}
            />
        </Form.Field>
    )
}

IntensityFormField.propTypes = {
    label: PropTypes.string.isRequired,
}

export default IntensityFormField
